<template>

    <!-- Page header -->
    <div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
        <div class="page-header-content d-lg-flex">
            <div class="d-flex">
                <h4 class="page-title mb-0">
                    <router-link href="#" class="text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
                    <a href="#" class="text-dark fw-semibold cursor-pointer" @click.prevent="tornaAlManuale()"> Manuale </a>
                    <template v-if="vistaArticolo && categoriaCorrente">
                        <span class="text-muted mx-1"> / </span>
                        <a href="#" class="text-dark fw-semibold cursor-pointer" @click.prevent="tornaAllaCategoria(categoriaCorrente.ID_CATEGORIA || categoriaCorrente.FK_ID_CATEGORIA)">{{ categoriaCorrente.DESCRIZIONE }}</a>
                    </template>
                    <span class="text-muted mx-1"> / </span>
                    <span class="text-muted">{{ breadcrumbCorrente }}</span>
                </h4>
                <a href="#page_header" class="btn btn-light align-self-center collapsed d-lg-none border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
                    <i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
                </a>
            </div>
        </div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#manuali-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="icon-menu7 me-2"></i><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Guide
							</div>
						</a>
					</li>
				</ul>


				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
							</div>
						</li>
						<li class="nav-item ms-1">
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	

    </div>
    <!-- /page header -->

    <!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1" v-if="!vistaArticolo">

			<div class="tab-pane fade active show" id="categorie-a" v-if="arrayCategorieVisibili.length">
        		<div class="card shadow mb-0">
	                <div class="card-body">
	                    <div class="d-sm-flex align-items-sm-start">
	                        <div class="form-control-feedback form-control-feedback-start flex-grow-1 mb-3 mb-sm-0">
	                            <input type="text" class="form-control" placeholder="Cerca nella knowledge base" v-model="searchQuery" @keyup.enter="eseguiRicerca">
	                            <div class="form-control-feedback-icon">
	                                <i class="ph-magnifying-glass"></i>
	                            </div>
	                        </div>
	                        <div class="dropdown ms-sm-3 mb-3 mb-sm-0">
	                            <select class="form-select" v-model="searchCategoria">
	                                <option value="0">Tutte le categorie</option>
	                                <option v-for="categoria in arrayCategorieVisibili" v-bind:key="categoria.ID_CATEGORIA" v-bind:value="categoria.ID_CATEGORIA">{{categoria.DESCRIZIONE}}</option>
	                            </select>
	                        </div>
	                        <div class="ms-sm-3">
	                            <button type="button" class="btn btn-primary w-100 w-sm-auto" @click="eseguiRicerca">Cerca</button>
	                        </div>
	                        <div class="ms-sm-2 mt-2 mt-sm-0" v-if="ricercaAttiva">
	                            <button type="button" class="btn btn-warning w-100 w-sm-auto" @click="azzeraRicerca()"><i class="ph-x me-1"></i>Azzera</button>
	                        </div>
	                    </div>
	                </div>
				</div>
            </div>
            <!-- /search field -->


            <!-- Risultati della ricerca -->
            <div class="manuale-search-summary d-flex align-items-center flex-wrap gap-2" v-if="ricercaAttiva">
                <h5 class="mb-0">Risultati della ricerca</h5>
                <span class="text-muted">{{ risultatiRicerca.length }} risultati per "{{ queryNormalizzata }}"</span>
            </div>

            <div class="card" v-if="ricercaAttiva">
                <div class="card-body p-0">
                    <div class="list-group list-group-flush" v-if="risultatiRicerca.length">
                        <a href="#" class="list-group-item list-group-item-action rounded-0" v-for="articolo in risultatiRicerca" v-bind:key="articolo.ID_CONTENUTO" @click.prevent="apriRisultato(articolo)">
                            <div class="manuale-result-row d-flex align-items-start">
                                <i class="ph-file-text me-3 mt-1 text-primary"></i>
                                <div class="manuale-result-content flex-fill">
                                    <div class="fw-semibold text-body">{{ articolo.TITOLO }}</div>
                                    <div class="text-muted fs-sm" v-if="articolo.SOTTOTITOLO || articolo.TESTO_HOME" v-html="excerptRisultato(articolo)"></div>
                                    <div class="fs-sm text-muted mt-1" v-if="categorieArticolo(articolo).length">
                                        <i class="ph-folder me-1"></i>{{ categorieArticolo(articolo).join(' · ') }}
                                    </div>
                                </div>
                                <div class="manuale-result-meta" v-if="dataPubblicazioneRisultato(articolo) || autoreRisultato(articolo)">
                                    <div class="manuale-result-meta-date" v-if="dataPubblicazioneRisultato(articolo)">
                                        <i class="ph-calendar me-1"></i>{{ dataPubblicazioneRisultato(articolo) }}
                                    </div>
                                    <div class="manuale-result-meta-author" v-if="autoreRisultato(articolo)">
                                        <i class="ph-user-circle me-1"></i>{{ etichettaAutore }}: {{ autoreRisultato(articolo) }}
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="card-body text-center py-5" v-else>
                        <i class="ph-magnifying-glass ph-3x text-muted mb-3 d-block"></i>
                        <h5 class="card-title">Nessun risultato trovato.</h5>
                        <span class="text-muted">Prova a modificare i termini di ricerca o la categoria.</span>
                    </div>
                </div>
            </div>
            <!-- /risultati della ricerca -->


            <!-- Home: solo quando nessuna ricerca è attiva -->
            <template v-if="!ricercaAttiva">

	            <!-- Directory -->
	            <div class="py-2 mb-3" v-if="arrayCategorieVisibili.length">
	                <h5 class="mb-0">Browse articles by category</h5>
	                <span class="text-muted">Yikes snuffed goat macaw overlay much and goodness and alas kookaburra a goldfish</span>
	            </div>

	            <div class="card" v-if="arrayCategorieVisibili.length">
	                <div class="card-body">
	                    <div class="row">
	                        <div class="col-lg-4" v-for="categoria in arrayCategorieVisibili" v-bind:key="categoria.ID_CATEGORIA">
	                            <div class="mb-4">
	                                <div class="fw-bold border-bottom pb-2 mt-1 mb-2"><i class="ph-folder me-2"></i> {{categoria.DESCRIZIONE}} <span class="ms-1">({{articoliPerCategoria(categoria.ID_CATEGORIA).length}})</span></div>
	                                <div v-if="categoria.SOTTOTITOLO" class="text-muted fs-sm mb-2">{{categoria.SOTTOTITOLO}}</div>
	                                <div class="list-group list-group-sm list-group-borderless">
	                                    <a href="#" class="list-group-item list-group-item-action rounded manuale-category-link" v-for="articolo in articoliPerCategoria(categoria.ID_CATEGORIA).slice(0,4)" v-bind:key="articolo.ID_CONTENUTO" @click.prevent="openArticolo(articolo, categoria.ID_CATEGORIA)">
	                                        <span class="manuale-category-title">
	                                            <i class="ph-file-text me-2"></i>
	                                            <span class="text-truncate">{{articolo.TITOLO}}</span>
	                                        </span>
	                                        <span class="manuale-category-badges" v-if="badgesArticolo(articolo).length">
	                                            <span class="badge manuale-article-badge" v-for="badge in badgesArticolo(articolo)" v-bind:key="badge.label" :class="badge.className">{{badge.label}}</span>
	                                        </span>
	                                    </a>
	                                    <div v-if="articoliPerCategoria(categoria.ID_CATEGORIA).length == 0" class="list-group-item rounded text-muted">Nessun articolo disponibile</div>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	            <!-- /directory -->


	            <!-- Latest added -->
	            <div class="py-2 mb-3" v-if="arrayArticoliRecenti.length">
	                <h5 class="mb-0">Ultimi articoli</h5>
	                <span class="text-muted">Gli articoli più recenti della knowledge base</span>
	            </div>

	            <div class="row" v-if="arrayArticoliRecenti.length">
	                <div class="col-lg-4" v-for="articolo in arrayArticoliRecenti" v-bind:key="articolo.ID_CONTENUTO">
	                    <div class="card">
	                        <div class="card-body d-flex align-items-start">
	                            <a href="#" class="bg-success bg-opacity-10 text-success rounded-pill p-2 me-3" @click.prevent="openArticolo(articolo)">
	                                <i class="ph-file-text"></i>
	                            </a>

	                            <div class="flex-fill">
	                                <h6 class="fw-semibold mb-1"><a href="#" class="text-body" @click.prevent="openArticolo(articolo)">{{articolo.TITOLO}}</a></h6>
	                                {{ escerpta(articolo.TESTO_HOME) }}
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	            <!-- /latest added -->


	            <!-- Empty state -->
	            <div class="card mt-2" v-if="!arrayCategorieVisibili.length && !arrayArticoliVisibili.length">
	                <div class="card-body text-center py-5">
	                    <i class="ph-book ph-3x text-muted mb-3 d-block"></i>
	                    <h5 class="card-title">Nessuna guida disponibile</h5>
	                    <span class="text-muted">Le guide verranno pubblicate prossimamente.</span>
	                </div>
	            </div>
	            <!-- /empty state -->

            </template>
            <!-- /home -->

        </div>
        <!-- ==================== /VISTA ELENCO ==================== -->


        <!-- ==================== VISTA ARTICOLO ==================== -->
        <div v-else>

            <!-- Header articolo -->
            <div class="card manuale-detail-title-card">
                <div class="card-body">
                    <div class="d-lg-flex align-items-start justify-content-between gap-3">
                        <div class="manuale-detail-heading">
                            <h4 class="fw-semibold mb-1">{{ articoloLangSelezionato.TITOLO }}</h4>
                            <p v-if="articoloLangSelezionato.SOTTOTITOLO" class="text-muted mb-0">{{ articoloLangSelezionato.SOTTOTITOLO }}</p>
                        </div>
                        <div class="manuale-detail-meta" v-if="dataPubblicazioneArticolo || autoreArticolo">
                            <div class="manuale-detail-meta-date" v-if="dataPubblicazioneArticolo">
                                <i class="ph-calendar me-1"></i>{{ dataPubblicazioneArticolo }}
                            </div>
                            <div class="manuale-detail-meta-author" v-if="autoreArticolo">
                                <i class="ph-user-circle me-1"></i>{{ etichettaAutore }}: {{ autoreArticolo }}
                            </div>
                        </div>
                    </div>
                    <img v-if="coverArticolo" :src="coverArticolo" class="img-fluid rounded mt-3 w-100" style="max-height: 260px; object-fit: cover;" alt="">
                </div>
            </div>
            <!-- /header articolo -->

            <div class="row">

                <!-- Colonna principale -->
                <div class="col-lg-8 order-2 order-lg-1">

                    <!-- Introduzione -->
                    <div class="card manuale-intro-card" v-if="articoloLangSelezionato.TESTO_HOME">
                        <div class="card-body d-flex align-items-start">
                            <div class="manuale-intro-icon"><i class="ph-info"></i></div>
                            <div class="flex-fill">
                                <h6 class="text-uppercase fw-semibold fs-sm mb-2">Introduzione</h6>
                                <div class="manuale-articolo" v-html="introduzioneArticolo" @click="handleArticoloClick" ref="manualeIntroduzione"></div>
                            </div>
                        </div>
                    </div>
                    <!-- /introduzione -->

                    <!-- Corpo -->
                    <div class="card manuale-body-card" v-if="corpoArticolo.html">
                        <div class="card-body">
                            <div class="manuale-articolo" v-html="corpoArticolo.html" @click="handleArticoloClick" ref="manualeCorpo"></div>
                        </div>
                    </div>
                    <!-- /corpo -->

                </div>
                <!-- /colonna principale -->

                <!-- Sidebar indice -->
                <div class="col-lg-4 order-1 order-lg-2 mb-3 manuale-sidebar-col" v-if="indiceArticolo.length || altreGuideCategoria.length">
                    <div class="manuale-sidebar-sticky">
                        <div class="card" v-if="indiceArticolo.length">
                            <div class="card-header py-2">
                                <h6 class="mb-0 fs-sm"><i class="ph-list me-2"></i>In questa guida</h6>
                            </div>
                            <div class="card-body p-2 manuale-sidebar-scroll">
                                <nav class="nav nav-pills flex-column">
                                    <a href="#" class="nav-link text-truncate py-1" :class="'indice-livello-' + voce.livello" v-for="voce in indiceArticolo" v-bind:key="voce.id" @click.prevent="vaiASezione(voce.id)">
                                        {{ voce.testo }}
                                    </a>
                                </nav>
                            </div>
                        </div>

                        <div class="card" v-if="altreGuideCategoria.length">
                            <div class="card-header py-2">
                                <h6 class="mb-0 fs-sm"><i class="ph-books me-2"></i>Altre guide della categoria</h6>
                            </div>
                            <div class="card-body p-2 manuale-sidebar-guides">
                                <nav class="nav nav-pills flex-column">
                                    <a href="#" class="nav-link text-truncate py-1" v-for="guida in altreGuideCategoria" v-bind:key="guida.ID_CONTENUTO" @click.prevent="openArticoloCondiviso(guida)">
                                        <i class="ph-file-text me-2"></i>{{ guida.TITOLO }}
                                    </a>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /sidebar indice -->

            </div>

        </div>
        <!-- ==================== /VISTA ARTICOLO ==================== -->

    </div>
    <!-- /content area -->

</template>
<script>

export default {
    name:"Manuale",

    data: function (){
        return{
            filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
            apiCategorie:'shared/categorie',
            apiContenuti:'shared/contenuti',
            apiContenuto:'shared/contenuti/singolo',
            arrayCategorie : new Array(),
            arrayContenuti : new Array(),
            articoloSelezionato:{langs:new Array()},
            articoloLangSelezionato:{},
            articoloCategorie:new Array(),
            categoriaContesto:null,
            vistaArticolo:false,
            searchCategoria:'0',
            searchQuery:'',
            ricercaAttiva:false,
            risultatiRicerca:new Array(),
            queryNormalizzata:'',
            paroleRicerca:new Array(),
            currentLang:0,
        }
    },

    methods: {
        getCategorie : function(){
            utils.ajax(this.apiCategorie,{}, (response) => {
                this.arrayCategorie = response.data || [];
            });
        },

        getContenuti : function(){
            utils.ajax(this.apiContenuti,{LANG:this.currentLang}, (response) => {
                this.arrayContenuti = response.data || [];
                for (let i = 0 ; i < this.arrayContenuti.length ; i++){
                    this.arrayContenuti[i].CATEGORIE = new Array();
                    var arrayCategorie = this.arrayContenuti[i].CATEGORIA ? this.arrayContenuti[i].CATEGORIA.split(",") : [];
                    var arrayId = this.arrayContenuti[i].ID_CATEGORIE ? this.arrayContenuti[i].ID_CATEGORIE.split(",") : [];
                    var arrayFinale = new Array();
                    for (var j = 0 ; j < arrayCategorie.length ; j++){
                        arrayFinale.push({FK_ID_CATEGORIA:arrayId[j],DESCRIZIONE:arrayCategorie[j]});
                    }
                    this.arrayContenuti[i].CATEGORIE = arrayFinale;
                }
            });
        },

        openArticolo : function(articolo, idCategoria){
            var articoloBase = utils.clone(articolo);
            this.categoriaContesto = idCategoria || null;
            this.articoloSelezionato = articoloBase;
            this.articoloLangSelezionato = {
                TITOLO: articolo.TITOLO,
                SOTTOTITOLO: articolo.SOTTOTITOLO,
                TESTO_HOME: articolo.TESTO_HOME,
                TESTO_BODY: articolo.TESTO_BODY
            };
            this.articoloCategorie = (articolo.CATEGORIE || []).slice();
            this.vistaArticolo = true;
            window.scrollTo(0,0);
            utils.get(this.apiContenuto,{ID_CONTENUTO:articolo.ID_CONTENUTO,LANG:this.currentLang}, (response) => {
                if (response.esito == 0 && response.data){
                    this.articoloSelezionato = Object.assign({}, articoloBase, response.data);
                    this.selezionaLangArticolo();
                    this.pianificaGestioneHelpImage();
                }
            });
            this.pianificaGestioneHelpImage();
        },

        openArticoloCondiviso : function(articolo){
            var idsCorrenti = (this.articoloCategorie || []).map((c) => c.FK_ID_CATEGORIA);
            var idsTarget = (articolo.CATEGORIE || []).map((c) => c.FK_ID_CATEGORIA);
            var contesto = null;
            for (var i = 0 ; i < idsTarget.length ; i++){
                if (idsCorrenti.indexOf(idsTarget[i]) != -1){
                    contesto = idsTarget[i];
                    break;
                }
            }
            this.openArticolo(articolo, contesto);
        },

        tornaAlManuale : function(){
            this.vistaArticolo = false;
            this.categoriaContesto = null;
            this.articoloSelezionato = {langs:new Array()};
            this.articoloLangSelezionato = {};
            this.articoloCategorie = new Array();
            this.azzeraRicerca();
            window.scrollTo(0,0);
        },

        tornaAllaCategoria : function(idCategoria){
            this.tornaAlManuale();
            if (idCategoria){
                this.searchQuery = '';
                this.searchCategoria = String(idCategoria);
                this.$nextTick(() => {
                    this.eseguiRicerca();
                });
            }
        },

        vaiASezione : function(id){
            var el = document.getElementById(id);
            if (el){
                el.scrollIntoView({behavior:'smooth', block:'start'});
            }
        },

        selezionaLangArticolo : function(){
            var langs = this.articoloSelezionato.langs || [];
            var found = false;
            for (var i = 0 ; i < langs.length ; i++){
                if (langs[i].FK_ID_LINGUA == this.currentLang){
                    this.articoloLangSelezionato = langs[i];
                    found = true;
                    break;
                }
            }
            if (!found && langs.length > 0){
                this.articoloLangSelezionato = langs[0];
            }
        },

        preparaCorpo : function(html, options){
            if (!html){
                return {html:'', indice:[]};
            }
            options = options || {};
            var self = this;
            html = html.replace(/<p>\s*\[HELP-IMAGE:([A-Z0-9_-]+)\]\s*<\/p>/g, function(match, codice){
                return self.buildHelpImage(codice);
            });
            html = html.replace(/\[HELP-IMAGE:([A-Z0-9_-]+)\]/g, function(match, codice){
                return self.buildHelpImage(codice);
            });
            html = html.replace(/\[HELP-LINK:([A-Za-z0-9_-]+)\|([^\]]+)\]/g, function(match, alias, label){
                return self.buildHelpLink(alias, label);
            });
            var div = document.createElement('div');
            div.innerHTML = html;
            this.rimuoviSezioniCorpo(div, ['Guide operative', 'Procedure correlate', 'Riepilogo']);
            if (options.rimuoviRiepilogoIniziale){
                this.rimuoviRiepilogoIniziale(div);
            }
            var headings = div.querySelectorAll('h2, h3, h4');
            var indice = [];
            for (var i = 0 ; i < headings.length ; i++){
                var h = headings[i];
                if (!h.id){
                    h.id = 'manuale-sezione-' + (i + 1);
                }
                indice.push({id:h.id, livello:parseInt(h.tagName.charAt(1)), testo:h.textContent.trim()});
            }
            var tables = div.querySelectorAll('table');
            for (var t = 0 ; t < tables.length ; t++){
                var wrapper = document.createElement('div');
                wrapper.className = 'table-responsive';
                tables[t].parentNode.insertBefore(wrapper, tables[t]);
                wrapper.appendChild(tables[t]);
            }
            return {html:div.innerHTML, indice:indice};
        },

        rimuoviRiepilogoIniziale : function(root){
            var primoTitolo = root.querySelector('h2, h3, h4');
            if (!primoTitolo){
                return;
            }
            var daRimuovere = [];
            var nodo = root.firstChild;
            while (nodo && nodo != primoTitolo){
                daRimuovere.push(nodo);
                nodo = nodo.nextSibling;
            }
            var contieneTesto = daRimuovere.some((n) => {
                return n.nodeType == 1 || String(n.textContent || '').trim() != '';
            });
            if (!contieneTesto){
                return;
            }
            for (var i = 0 ; i < daRimuovere.length ; i++){
                if (daRimuovere[i].parentNode){
                    daRimuovere[i].parentNode.removeChild(daRimuovere[i]);
                }
            }
        },

        rimuoviSezioniCorpo : function(root, titoli){
            var headings = Array.prototype.slice.call(root.querySelectorAll('h2, h3, h4'));
            var titoliNormalizzati = titoli.map((t) => String(t).trim().toLowerCase());
            for (var i = 0 ; i < headings.length ; i++){
                var heading = headings[i];
                var testo = String(heading.textContent || '').trim().toLowerCase();
                if (titoliNormalizzati.indexOf(testo) == -1){
                    continue;
                }
                var livello = parseInt(heading.tagName.charAt(1));
                var daRimuovere = [heading];
                var nodo = heading.nextSibling;
                while (nodo){
                    if (nodo.nodeType == 1 && /^H[2-4]$/.test(nodo.tagName) && parseInt(nodo.tagName.charAt(1)) <= livello){
                        break;
                    }
                    daRimuovere.push(nodo);
                    nodo = nodo.nextSibling;
                }
                for (var r = 0 ; r < daRimuovere.length ; r++){
                    if (daRimuovere[r].parentNode){
                        daRimuovere[r].parentNode.removeChild(daRimuovere[r]);
                    }
                }
            }
        },

        buildHelpImage : function(codice){
            var src = this.GLOBAL_IMAGES_PATH + 'CONTENUTO/help/' + codice + '.jpg';
            return '<figure class="manuale-help-screenshot" data-help-code="' + codice + '">' +
                '<div class="manuale-help-placeholder">' +
                    '<i class="ph-image text-muted"></i>' +
                    '<div class="manuale-help-placeholder-title">Screenshot da inserire</div>' +
                    '<code>' + codice + '</code>' +
                '</div>' +
                '<img class="manuale-help-img" src="' + src + '" alt="' + codice + '" data-help-code="' + codice + '" style="display:none;">' +
            '</figure>';
        },

        buildHelpLink : function(alias, label){
            if (!/^[A-Za-z0-9_-]+$/.test(alias)){
                return label || alias;
            }
            var articolo = null;
            for (var i = 0 ; i < this.arrayArticoliVisibili.length ; i++){
                if (this.arrayArticoliVisibili[i].ALIAS == alias){
                    articolo = this.arrayArticoliVisibili[i];
                    break;
                }
            }
            if (!articolo){
                return label || alias;
            }
            return '<a href="#" class="manuale-help-link" data-help-alias="' + alias + '">' + (label || alias) + '</a>';
        },

        handleArticoloClick : function(event){
            var link = event.target && event.target.closest ? event.target.closest('[data-help-alias]') : null;
            if (!link){
                return;
            }
            event.preventDefault();
            var alias = link.getAttribute('data-help-alias');
            if (!alias){
                return;
            }
            var articolo = null;
            for (var i = 0 ; i < this.arrayArticoliVisibili.length ; i++){
                if (this.arrayArticoliVisibili[i].ALIAS == alias){
                    articolo = this.arrayArticoliVisibili[i];
                    break;
                }
            }
            if (articolo){
                this.openArticoloCondiviso(articolo);
            }
        },

        pianificaGestioneHelpImage : function(){
            this.$nextTick(() => {
                this.gestisciHelpImage();
                setTimeout(() => {
                    this.gestisciHelpImage();
                }, 500);
                setTimeout(() => {
                    this.gestisciHelpImage();
                }, 1500);
            });
        },

        gestisciHelpImage : function(){
            if (!this.vistaArticolo){
                return;
            }
            var imgs = [];
            var contenitori = [this.$refs.manualeIntroduzione, this.$refs.manualeCorpo];
            for (var c = 0 ; c < contenitori.length ; c++){
                var root = contenitori[c];
                if (!root || typeof root.querySelectorAll != 'function'){
                    continue;
                }
                imgs = imgs.concat(Array.prototype.slice.call(root.querySelectorAll('.manuale-help-img')));
            }
            for (var i = 0 ; i < imgs.length ; i++){
                var img = imgs[i];
                var figure = img.closest('.manuale-help-screenshot');
                var placeholder = figure ? figure.querySelector('.manuale-help-placeholder') : null;
                var mostraImg = function(){
                    img.style.display = '';
                    if (placeholder){
                        placeholder.style.display = 'none';
                    }
                };
                var mostraPlaceholder = function(){
                    img.style.display = 'none';
                    if (placeholder){
                        placeholder.style.display = '';
                    }
                };
                var tentativi = 0;
                var controllaCaricamento = function(){
                    if (img.naturalWidth > 0){
                        mostraImg();
                        return;
                    }
                    mostraPlaceholder();
                    tentativi++;
                    if (tentativi < 20){
                        setTimeout(controllaCaricamento, 150);
                    }
                };
                if (!img.__helpGestito){
                    img.__helpGestito = true;
                    img.addEventListener('load', mostraImg);
                    img.addEventListener('error', mostraPlaceholder);
                }
                controllaCaricamento();
            }
        },

        articoliPerCategoria : function(idCategoria){
            return this.arrayArticoliVisibili.filter((c) => {
                return (c.CATEGORIE || []).some((cat) => cat.FK_ID_CATEGORIA == idCategoria);
            });
        },

        dataArticolo : function(articolo, campi){
            for (var i = 0 ; i < campi.length ; i++){
                var valore = articolo[campi[i]];
                if (!valore || valore == '0000-00-00 00:00:00'){
                    continue;
                }
                var data = this.parseDataManuale(valore);
                if (data){
                    return data.getTime();
                }
            }
            return 0;
        },

        parseDataManuale : function(value){
            if (!value || value == '0000-00-00 00:00:00' || value == '1899-01-01 00:00:00' || value == '01/01/1899'){
                return null;
            }
            var text = String(value).trim();
            var matchIt = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
            if (matchIt){
                return new Date(
                    parseInt(matchIt[3]),
                    parseInt(matchIt[2]) - 1,
                    parseInt(matchIt[1]),
                    parseInt(matchIt[4] || 0),
                    parseInt(matchIt[5] || 0),
                    parseInt(matchIt[6] || 0)
                );
            }
            var matchIso = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
            if (matchIso){
                return new Date(
                    parseInt(matchIso[1]),
                    parseInt(matchIso[2]) - 1,
                    parseInt(matchIso[3]),
                    parseInt(matchIso[4] || 0),
                    parseInt(matchIso[5] || 0),
                    parseInt(matchIso[6] || 0)
                );
            }
            var data = new Date(text.replace(' ', 'T'));
            return isNaN(data.getTime()) ? null : data;
        },

        giorniDa : function(timestamp){
            if (!timestamp){
                return null;
            }
            return (Date.now() - timestamp) / 86400000;
        },

        articoloAggiornato : function(articolo){
            var dataEdit = this.dataArticolo(articolo, ['DATE_EDIT']);
            var dataAdd = this.dataArticolo(articolo, ['DATE_ADD']);
            var giorni = this.giorniDa(dataEdit);
            return giorni !== null && giorni <= 30 && (!dataAdd || dataEdit - dataAdd > 3600000);
        },

        articoloNuovo : function(articolo){
            var dataAdd = this.dataArticolo(articolo, ['DATE_ADD']);
            var giorni = this.giorniDa(dataAdd);
            return giorni !== null && giorni <= 14;
        },

        sogliaPopolare : function(){
            var counters = this.arrayArticoliVisibili
                .map((a) => Number(a.COUNTER || 0))
                .filter((counter) => counter > 0);
            if (!counters.length){
                return 50;
            }
            return Math.max(50, Math.ceil(Math.max.apply(null, counters) * 0.75));
        },

        badgesArticolo : function(articolo){
            var badges = new Array();
            if (this.articoloAggiornato(articolo)){
                badges.push({label:'Updated', className:'manuale-badge-updated'});
            }
            if (Number(articolo.COUNTER || 0) >= this.sogliaPopolare()){
                badges.push({label:'Popolare', className:'manuale-badge-popular'});
            }
            if (!badges.length && this.articoloNuovo(articolo)){
                badges.push({label:'Nuovo', className:'manuale-badge-new'});
            }
            if (articolo.FLG_INHOME == 1){
                badges.push({label:'In evidenza', className:'manuale-badge-featured'});
            }
            return badges.slice(0,2);
        },

        linguaCorrente : function(){
            var lingue = this.$root.arrayLingue || [];
            for (var i = 0 ; i < lingue.length ; i++){
                if (lingue[i].ID_GEO_STATO == this.currentLang){
                    return lingue[i];
                }
            }
            return {};
        },

        localeManuale : function(){
            var lingua = this.linguaCorrente();
            var id = String(this.currentLang || '');
            var testo = String([lingua.NOME, lingua.DESCRIZIONE, lingua.SIGLA, lingua.CODICE, lingua.ICONA].filter(Boolean).join(' ')).toLowerCase();
            if (id == '118' || testo.indexOf('ital') != -1 || testo.indexOf('it') != -1){
                return 'it-IT';
            }
            if (testo.indexOf('eng') != -1 || testo.indexOf('ingl') != -1 || testo.indexOf('en') != -1){
                return 'en-GB';
            }
            if (testo.indexOf('fr') != -1){
                return 'fr-FR';
            }
            if (testo.indexOf('de') != -1 || testo.indexOf('ted') != -1){
                return 'de-DE';
            }
            if (testo.indexOf('es') != -1 || testo.indexOf('spa') != -1){
                return 'es-ES';
            }
            return 'it-IT';
        },

        testoMeta : function(chiave){
            var lingua = this.localeManuale().split('-')[0];
            var testi = {
                author:{it:'Autore', en:'Author', fr:'Auteur', de:'Autor', es:'Autor'},
                editorial:{it:'Redazione', en:'Editorial team', fr:'Redaction', de:'Redaktion', es:'Redaccion'}
            };
            return testi[chiave] && testi[chiave][lingua] ? testi[chiave][lingua] : testi[chiave].it;
        },

        formattaDataManuale : function(value){
            if (!value || value == '0000-00-00 00:00:00' || value == '1899-01-01 00:00:00'){
                return '';
            }
            var data = this.parseDataManuale(value);
            if (!data){
                return '';
            }
            return new Intl.DateTimeFormat(this.localeManuale(), {
                day:'numeric',
                month:'long',
                year:'numeric'
            }).format(data);
        },

        autoreDaId : function(idUtente){
            var utenti = this.$root.arrayUtentiAdmin || [];
            for (var i = 0 ; i < utenti.length ; i++){
                if (utenti[i].ID_UTENTE == idUtente){
                    return utenti[i].USERNAME || utenti[i].NOME || '';
                }
            }
            return '';
        },

        valoreAutoreArticolo : function(articolo){
            articolo = articolo || this.articoloSelezionato || {};
            var campi = ['AUTORE', 'AUTHOR', 'USERNAME', 'UTENTE', 'CREATED_BY', 'CUSTOM_1', 'CUSTOM_2'];
            for (var i = 0 ; i < campi.length ; i++){
                var value = articolo[campi[i]];
                if (value === null || value === undefined || String(value).trim() == ''){
                    continue;
                }
                var testo = String(value).trim();
                if (/^\d+$/.test(testo)){
                    return this.autoreDaId(testo) || testo;
                }
                return testo;
            }
            return this.testoMeta('editorial');
        },

        dataPubblicazioneRisultato : function(articolo){
            return this.formattaDataManuale(articolo.DATE_ADD);
        },

        autoreRisultato : function(articolo){
            return this.valoreAutoreArticolo(articolo);
        },

        escerpta : function(html, length = 100){
            if (!html){
                return '';
            }
            var text = String(html).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
            if (!text){
                return '';
            }
            return text.length > length ? text.substring(0, length).trim() + '...' : text;
        },

        pulisciTesto : function(html){
            if (!html){
                return '';
            }
            return String(html).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
        },

        testoRicercaArticolo : function(articolo){
            var campi = [articolo.TITOLO, articolo.METAKEY, articolo.SOTTOTITOLO, articolo.TESTO_HOME, articolo.TESTO_BODY];
            var testo = campi.map((c) => this.pulisciTesto(c)).join(' ');
            return ' ' + testo + ' ';
        },

        articoloInCategoria : function(articolo, idCategoria){
            var id = String(idCategoria);
            return (articolo.CATEGORIE || []).some((c) => String(c.FK_ID_CATEGORIA) == id);
        },

        punteggioArticolo : function(articolo, parole){
            var punteggio = 0;
            for (var i = 0 ; i < parole.length ; i++){
                var p = parole[i];
                if (this.pulisciTesto(articolo.TITOLO).split(' ').indexOf(p) != -1){
                    punteggio += 4;
                }
                if (this.pulisciTesto(articolo.METAKEY).split(' ').indexOf(p) != -1){
                    punteggio += 3;
                }
                if (this.pulisciTesto(articolo.SOTTOTITOLO).split(' ').indexOf(p) != -1){
                    punteggio += 2;
                }
                if (this.pulisciTesto(articolo.TESTO_HOME).split(' ').indexOf(p) != -1){
                    punteggio += 1;
                }
                if (this.pulisciTesto(articolo.TESTO_BODY).split(' ').indexOf(p) != -1){
                    punteggio += 1;
                }
            }
            return punteggio;
        },

        ordinaRisultati : function(risultati, parole){
            var self = this;
            var arr = risultati.slice();
            arr.sort((a,b) => {
                var sa = self.punteggioArticolo(a, parole);
                var sb = self.punteggioArticolo(b, parole);
                if (sb != sa){
                    return sb - sa;
                }
                return (a.ORDINE || 0) - (b.ORDINE || 0);
            });
            return arr;
        },

        eseguiRicerca : function(){
            var query = String(this.searchQuery || '').trim().replace(/\s+/g, ' ');
            var idCategoria = String(this.searchCategoria || '0');
            var parole = query.toLowerCase().split(' ').filter((p) => p.length > 0);
            if (query == '' && idCategoria == '0'){
                this.azzeraRicerca();
                return;
            }
            var self = this;
            var risultati = new Array();
            for (var i = 0 ; i < this.arrayArticoliVisibili.length ; i++){
                var articolo = this.arrayArticoliVisibili[i];
                if (idCategoria != '0' && !self.articoloInCategoria(articolo, idCategoria)){
                    continue;
                }
                if (parole.length == 0){
                    risultati.push(articolo);
                    continue;
                }
                var testo = self.testoRicercaArticolo(articolo);
                var corrisponde = true;
                for (var w = 0 ; w < parole.length ; w++){
                    if (testo.indexOf(parole[w]) == -1){
                        corrisponde = false;
                        break;
                    }
                }
                if (corrisponde){
                    risultati.push(articolo);
                }
            }
            this.ricercaAttiva = true;
            this.queryNormalizzata = query;
            this.paroleRicerca = parole;
            this.risultatiRicerca = this.ordinaRisultati(risultati, parole);
        },

        azzeraRicerca : function(){
            this.searchQuery = '';
            this.searchCategoria = '0';
            this.ricercaAttiva = false;
            this.risultatiRicerca = new Array();
            this.queryNormalizzata = '';
            this.paroleRicerca = new Array();
        },

        apriRisultato : function(articolo){
            var idCategoria = String(this.searchCategoria || '0') != '0' ? this.searchCategoria : null;
            this.openArticolo(articolo, idCategoria);
        },

        categorieArticolo : function(articolo){
            return (articolo.CATEGORIE || []).map((c) => c.DESCRIZIONE).filter(Boolean);
        },

        escapeRegExp : function(text){
            return String(text).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        },

        evidenziaTesto : function(testo, parole){
            if (!testo || !parole || !parole.length){
                return this.escerpta(testo);
            }
            var escaped = this.escerpta(testo, 160)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
            for (var i = 0 ; i < parole.length ; i++){
                var re = new RegExp(this.escapeRegExp(parole[i]), 'gi');
                escaped = escaped.replace(re, function(m){
                    return '<mark class="manuale-mark">' + m + '</mark>';
                });
            }
            return escaped;
        },

        excerptRisultato : function(articolo){
            var base = articolo.SOTTOTITOLO ? articolo.SOTTOTITOLO : this.escerpta(articolo.TESTO_HOME, 160);
            return this.evidenziaTesto(base, this.paroleRicerca);
        }
    },

    computed: {
        breadcrumbCorrente(){
            if (this.vistaArticolo){
                return this.articoloLangSelezionato.TITOLO;
            }
            if (this.ricercaAttiva){
                return 'Risultati ricerca';
            }
            return 'Knowledge Base';
        },

        arrayCategorieVisibili(){
            return this.arrayCategorie
                .filter((c) => c.FLG_VISIBILE == 1 && c.FLG_ATTIVO == 1)
                .sort((a,b) => (a.ORDINE || 0) - (b.ORDINE || 0));
        },

        arrayArticoliVisibili(){
            return this.arrayContenuti
                .filter((c) => c.FLG_VISIBILE == 1 && c.FLG_ATTIVO == 1)
                .sort((a,b) => (a.ORDINE || 0) - (b.ORDINE || 0));
        },

        arrayArticoliRecenti(){
            var arr = this.arrayArticoliVisibili.slice();
            arr.sort((a,b) => {
                var da = a.DATE_ADD ? new Date(a.DATE_ADD).getTime() : 0;
                var db = b.DATE_ADD ? new Date(b.DATE_ADD).getTime() : 0;
                return db - da;
            });
            return arr.slice(0,6);
        },

        categoriaCorrente(){
            if (!this.articoloCategorie.length){
                return null;
            }
            var scelta = null;
            if (this.categoriaContesto){
                scelta = this.articoloCategorie.find((c) => c.FK_ID_CATEGORIA == this.categoriaContesto) || null;
            }
            if (!scelta){
                scelta = this.articoloCategorie[0];
            }
            return this.arrayCategorieVisibili.find((c) => c.ID_CATEGORIA == scelta.FK_ID_CATEGORIA) || scelta;
        },

        altreGuideCategoria(){
            if (!this.articoloCategorie.length){
                return [];
            }
            var ids = this.articoloCategorie.map((c) => c.FK_ID_CATEGORIA);
            return this.arrayArticoliVisibili.filter((a) => {
                return a.ID_CONTENUTO != this.articoloSelezionato.ID_CONTENUTO && (a.CATEGORIE || []).some((c) => ids.indexOf(c.FK_ID_CATEGORIA) != -1);
            }).slice(0,5);
        },

        corpoArticolo(){
            return this.preparaCorpo(this.articoloLangSelezionato.TESTO_BODY, {rimuoviRiepilogoIniziale:true});
        },

        introduzioneArticolo(){
            return this.preparaCorpo(this.articoloLangSelezionato.TESTO_HOME).html;
        },

        indiceArticolo(){
            return this.corpoArticolo.indice;
        },

        dataPubblicazioneArticolo(){
            return this.formattaDataManuale(this.articoloSelezionato.DATE_ADD || this.articoloLangSelezionato.DATE_ADD);
        },

        autoreArticolo(){
            return this.valoreAutoreArticolo();
        },

        etichettaAutore(){
            return this.testoMeta('author');
        },

        coverArticolo(){
            var url = this.articoloSelezionato.URL_AVATAR;
            if (!url || url == 'placeholder.jpg'){
                return '';
            }
            return this.filters.getImgPath('CONTENUTO', url);
        }
    },

    created : function(){
        global.utils.BASE_API = process.env.VUE_APP_API_URL;
        this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
        this.currentLang = this.$root.currentLang;
        this.getCategorie();
        this.getContenuti();
    },

    updated : function(){
        this.gestisciHelpImage();
    }
}
</script>

<style scoped>
    .manuale-articolo :deep(h1){font-size:1.5rem;font-weight:600;margin:0 0 0.75rem;}
    .manuale-articolo :deep(h2){font-size:1.35rem;font-weight:600;margin:1.75rem 0 0.75rem;padding-bottom:0.35rem;border-bottom:1px solid #e1e6ee;scroll-margin-top:1rem;}
    .manuale-articolo :deep(h3){font-size:1.15rem;font-weight:600;margin:1.5rem 0 0.6rem;scroll-margin-top:1rem;}
    .manuale-articolo :deep(h4){font-size:1.05rem;font-weight:600;margin:1.25rem 0 0.5rem;scroll-margin-top:1rem;}
    .manuale-articolo :deep(p){line-height:1.65;margin-bottom:0.85rem;}
    .manuale-articolo :deep(ul){padding-left:1.4rem;margin-bottom:0.85rem;}
    .manuale-articolo :deep(ol){padding-left:1.4rem;margin-bottom:0.85rem;}
    .manuale-articolo :deep(li){margin-bottom:0.35rem;line-height:1.6;}
    .manuale-articolo :deep(strong),.manuale-articolo :deep(b){font-weight:600;}
    .manuale-articolo :deep(img){max-width:100%;height:auto;border-radius:0.5rem;}
    .manuale-articolo :deep(table){width:100%;margin:0.85rem 0;border-collapse:collapse;font-size:0.9rem;}
    .manuale-articolo :deep(th){padding:0.55rem;border:1px solid #dde3ec;background:#f5f7fb;font-weight:600;}
    .manuale-articolo :deep(td){padding:0.55rem;border:1px solid #dde3ec;}
    .manuale-articolo :deep(blockquote){border-left:3px solid #3e90f9;padding:0.6rem 1rem;background:#f8faff;margin:0.85rem 0;border-radius:0.4rem;}
    .manuale-articolo :deep(hr){margin:1.25rem 0;border-color:#e1e6ee;}
    .manuale-articolo :deep(code){background:#f3f5f9;border:1px solid #e1e6ee;border-radius:0.3rem;padding:0.1rem 0.35rem;font-size:0.85em;}
    .manuale-articolo :deep(pre){background:#28313f;color:#eef2f7;padding:0.9rem 1rem;border-radius:0.5rem;overflow-x:auto;margin:0.85rem 0;}
    .manuale-articolo :deep(pre code){background:transparent;border:0;padding:0;color:inherit;}
    .manuale-articolo :deep(.alert){border-radius:0.5rem;}
    .manuale-articolo :deep(.alert p:last-child){margin-bottom:0;}
    .indice-livello-2{padding-left:0.85rem !important;font-size:0.85rem;}
    .indice-livello-3{padding-left:1.6rem !important;font-size:0.82rem;}
    .indice-livello-4{padding-left:2.3rem !important;font-size:0.8rem;}
    .manuale-help-screenshot{margin:1.25rem 0;}
    .manuale-help-img{max-width:100%;height:auto;border-radius:0.5rem;box-shadow:0 1px 3px rgba(0,0,0,0.08);}
    .manuale-help-placeholder{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0.4rem;padding:2.25rem 1rem;border:1px dashed #c7d0df;border-radius:0.5rem;background:#f8fafd;text-align:center;}
    .manuale-help-placeholder i{font-size:2rem;opacity:0.45;}
    .manuale-help-placeholder-title{font-weight:600;color:#637083;font-size:0.9rem;}
    .manuale-help-placeholder code{background:#eef1f6;border:1px solid #e1e6ee;border-radius:0.3rem;padding:0.1rem 0.4rem;font-size:0.8em;}
    .manuale-help-link{color:#3e90f9;text-decoration:underline;cursor:pointer;}
    .manuale-help-link:hover{color:#1f6fd6;}
    .manuale-mark{background:rgba(62,144,249,0.15);color:#1f6fd6;border-radius:0.2rem;padding:0 0.1rem;}
    .manuale-search-summary{min-height:2.5rem;margin:1rem 0;line-height:1.3;}
    .manuale-search-summary h5{line-height:1.3;}
    .manuale-result-row{gap:1rem;}
    .manuale-result-content{min-width:0;}
    .manuale-result-meta{flex:0 0 auto;min-width:12rem;text-align:right;color:#6f7785;font-size:0.82rem;line-height:1.45;}
    .manuale-result-meta-date{font-weight:600;color:#3b4656;}
    .manuale-result-meta-author{margin-top:0.2rem;}
    .form-control-feedback { top: 0; left: 0; }
    .manuale-category-link{display:flex;align-items:center;gap:0.75rem;min-height:2.35rem;}
    .manuale-category-title{display:flex;align-items:center;min-width:0;flex:1;}
    .manuale-category-title i{flex:0 0 auto;}
    .manuale-category-badges{display:flex;align-items:center;gap:0.35rem;flex:0 0 auto;margin-left:auto;white-space:nowrap;}
    .manuale-article-badge{border-radius:0.25rem;padding:0.32rem 0.55rem;font-size:0.72rem;font-weight:600;line-height:1;}
    .manuale-badge-updated{background:#3e90f9;color:#fff;}
    .manuale-badge-popular{background:#3e90f9;color:#fff;}
    .manuale-badge-new{background:#26a69a;color:#fff;}
    .manuale-badge-featured{background:#5c6bc0;color:#fff;}
    .manuale-detail-title-card .card-body{padding:1.35rem 1.5rem;}
    .manuale-detail-title-card h4{font-size:1.45rem;}
    .manuale-detail-heading{min-width:0;flex:1;}
    .manuale-detail-meta{flex:0 0 auto;min-width:13rem;margin-top:0.2rem;text-align:right;color:#6f7785;font-size:0.85rem;line-height:1.45;}
    .manuale-detail-meta-date{font-weight:600;color:#3b4656;}
    .manuale-detail-meta-author{margin-top:0.25rem;}
    .manuale-sidebar-sticky .card-header h6{font-weight:600;color:#2f3a4a;}
    .manuale-intro-card{border-left:4px solid #3e90f9;background:#f4f8ff;}
    .manuale-intro-card .card-body{padding:1rem 1.15rem;}
    .manuale-intro-card h6{color:#1f6fd6;}
    .manuale-intro-card .manuale-articolo :deep(p:last-child){margin-bottom:0;}
    .manuale-intro-icon{display:flex;align-items:center;justify-content:center;width:2.1rem;height:2.1rem;min-width:2.1rem;margin-right:0.85rem;border-radius:50%;background:#dcecff;color:#1f6fd6;font-size:1.1rem;}
    .manuale-sidebar-sticky .card + .card{margin-top:1rem;}
    @media (max-width: 991.98px){
        .manuale-detail-meta{min-width:0;text-align:left;margin-top:1rem;}
    }
    @media (max-width: 767.98px){
        .manuale-result-row{display:block !important;}
        .manuale-result-meta{min-width:0;margin-top:0.5rem;margin-left:2.35rem;text-align:left;}
    }
    @media (min-width: 992px){
        .manuale-sidebar-sticky{position:sticky;top:1rem;}
        .manuale-sidebar-scroll{max-height:calc(100vh - 14rem);overflow-y:auto;}
    }
</style>
